import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { solidCircleIcon } from "../../MapMarkerIcons/MapMarkerIcons";

export function CheckinVisitasPersonalViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const cadena = record[1] as string;
    const tienda = record[2] as string;
    const domicilio = record[3] as string;
    const diferencia = record[8] as string;

    const icon = solidCircleIcon;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `Checkin: ${cadena} - ${tienda} - ${domicilio} - Distancia a tienda: ${diferencia}m`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.orange[6],
    }

    return markerProps;
}